import { render } from "./Login.vue?vue&type=template&id=5dedde2f&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=5dedde2f&scoped=true&lang=css"

import exportComponent from "E:\\coding\\pharaoh_frog_barber\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dedde2f"]])

export default __exports__